export default "__VITE_ASSET__ks5YAJ2FYO7Gp3xJ$8WfPQ__";